import PersonAttachmentsPageContent from '@/components/PersonAttachmentsPageContent';
import useProfile from '@/hooks/useProfileV2';

const HomeAttachments = (): JSX.Element => {
  const { profile } = useProfile();

  return <PersonAttachmentsPageContent person={profile.person || undefined} readonly />;
};

export default HomeAttachments;
